import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import "./css/nOperator.css";
import { AnimatedSwitch, spring } from "react-router-transition";
import DrSupport from "./app/support/drSupport";
import cookie from "react-cookies";
import axios from "axios";
import Comment from "./app/nuser/comment/comment";
import Comments from "./app/doctor/comments/comments";
import AddComment from "./app/doctor/add-comment/add-comment";
import Accounting from "./app/accounting";
import Factor from "./app/accounting/factor";

let nobat_cookie = cookie.loadAll();
delete nobat_cookie.topbar_v1;
delete nobat_cookie.top_bar;

axios.defaults.headers.common["Nobat-Cookie"] = JSON.stringify(nobat_cookie);

function mapStyles(styles) {
  return {
    opacity: styles.opacity,
  };
}

function bounce(val) {
  return spring(val, {
    stiffness: 330,
    damping: 22,
  });
}

const bounceTransition = {
  atEnter: {
    opacity: 0,
  },
  atLeave: {
    opacity: bounce(0),
  },
  atActive: {
    opacity: bounce(1),
  },
};

let base = "/";
const routers = (
  <Router basename={base}>
    <AnimatedSwitch
      atEnter={bounceTransition.atEnter}
      atLeave={bounceTransition.atLeave}
      atActive={bounceTransition.atActive}
      mapStyles={mapStyles}
      className="switch-wrapper"
    >
      <Route exact path="/dr/support/:d_id" component={DrSupport} />
      <Route exact path="/dr/comments/add/:d_id" component={AddComment} />
      <Route exact path="/dr/comments/:d_id" component={Comments} />
      <Route exact path="/user/comment/" component={Comment} />
      <Route exact path="/accounting/:pincode" component={Accounting} />
      <Route exact path="/accounting/factor/:pincode" component={Factor} />
    </AnimatedSwitch>
  </Router>
);
window.server = "https://api.nobat.ir";
window.appServer = "https://api.nobat.ir/app/v1/office";
// window.serverPic = 'https://nobat.ir';
// window.server = 'http://192.168.138.50:8200';

ReactDOM.render(routers, document.getElementById("root"));
serviceWorker.unregister();
